export const LANGUAGE_QUERY_PARAM = 'lang';
export const STEP_UP_LANGUAGE_QUERY_PARAM = 'language';
